<template>
  <div>
    <div
      v-if="showContainer"
      :class="[
        classMain,
        `border-left--color-${borderColor ? borderColor : 'secondary-12'}`,
        {
          'border--left': hasBorder,
        },
      ]"
      class="bg-secondary-3 border-radius--light"
    >
      <div class="row">
        <div 
            :class="{'gradient-toggle': hasGradient && hasToggle}"
            class="ml-3 d-flex align-items-center px-1">
          <em
            v-if="hasToggle" 
            @click="open"
            :class="{
              'fa-chevron-circle-right color-primary-2': !isOpen,
              'fa-chevron-circle-down color-primary-1': isOpen,
            }"
            class="far font-20"
          />
        </div>
        <div 
          :class="{'ml-2': hasGradient}"
          class="col p-2">
           <slot />
        </div>
      </div>
    </div>

    <div
      v-if="isOpen"
      :class="classPanel"
      class="bg-secondary-3 border-radius--light p-0"
    >
      <slot name="edition" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Callout',
  props: {
    hasBorder: {
      type: Boolean,
      default: () => true,
    },
    hasToggle: {
      type: Boolean,
      default: () => true,
    },
    borderColor: {
      type: String,
      default: () => null,
    },
    opened: {
      type: Boolean,
      default: () => false,
    },
    controlled: {
      type: Boolean,
      default: () => false,
    },
    classMain: {
      type: String,
      default: () => '',
    },
    classPanel: {
      type: String,
      default: () => '',
    },
    hasGradient: {
      type: Boolean,
      default: () => true,
    },
    showContainer: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      isOpen: null,
    }
  },
  watch: {
    opened: {
      handler(value) {
        this.isOpen = value
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      if (!this.controlled) {
        this.isOpen = !this.isOpen
      } 
      else {
        this.$emit("click:open")
      }
    },
  },
}
</script>

<style scoped>
.border--left {
  border-left-style: solid;
  border-left-width: 3px;
}

.gradient-toggle {
  box-shadow: 5px 0px 5px #E2E2E2;
}
</style>